const home = {
  eyebrow: 'TOF Persona Team',
  heroTitle: 'Je profiel maak je in de app.',
  heroTitleAccent: 'Hier komt je team samen.',
  heroLead:
    'Ieder teamlid doet de test in de app TOF Persona. Hier lees je wat die profielen samen zeggen: welke werkstijlen je team heeft, waar energie zit en waar het schuurt.',

  // Opent het codevenster.
  ctaTeamEnvironment: 'Ik heb een toegangscode',
  // Naar /quiz, dat op het web het storescherm is.
  ctaApp: 'Doe de test in de app',

  offerCard: {
    eyebrow: 'Voor jezelf',
    title: 'De app TOF Persona',
    text: 'Je eigen profiel: hoe je werkt, waar je energie van krijgt en wat je nodig hebt. Heb je een teamcode, dan breng je het daarna in bij je team.',
  },

  teamCard: {
    eyebrow: 'Voor je team',
    titleLine1: 'Je team werkt.',
    titleLine2: 'Werkt het ook samen?',
    text: 'Zie wat Teaminzicht en Teamdynamiek over je team laten zien. Wil je verder kijken, dan zijn er het Organisatielandschap en het Strategisch Kompas.',
  },

  footer: {
    logoAlt: 'TOF logo',
    body: 'TOF Persona is ontwikkeld door The Office Factory, die werkomgeving, digitale middelen en gedrag in samenhang bekijkt.',
    website: 'Ga naar website →',
    contact: 'Plan een gesprek',
    privacy:
      '🔒 Data wordt anoniem gebruikt voor analyse en niet gedeeld met derden. Naam is optioneel.',
    // App-modus: er gaat niets naar een server, dus de webzin klopt daar niet.
    privacyNative:
      '🔒 Alles blijft op je toestel. Je antwoorden en je profiel gaan niet naar een server en worden met niemand gedeeld. Naam is optioneel.',
  },

  lock: {
    eyebrow: 'Teamomgeving',
    title: 'Voer je toegangscode in',
    body: 'De teamomgeving is alleen toegankelijk met een persoonlijke code.',
    placeholder: 'Voer code in',
    errorEmpty: 'Voer eerst een toegangscode in',
    errorCheck: 'Er ging iets mis bij het controleren van de code',
    errorUnknown: 'Onjuiste of onbekende code',
    checking: 'Controleren...',
    submit: 'Ga verder',
    close: 'Sluiten',
  },
};

export default home;
